var o = /* @__PURE__ */ ((a) => (a.custom = "custom", a.architecture = "architecture", a.abstract = "abstract", a.openings = "openings", a.modules = "modules", a.apartments = "apartments", a.rooms = "rooms", a))(o || {});
export {
  o as VisibilityPreset
};
//# sourceMappingURL=index.js.map
